// Deterministic client-side recommendation fallback.
// Mirrors backend lib/fallback.py logic but runs purely in the browser
// so the user NEVER reaches a dead end — even if the API is down,
// times out, or returns invalid JSON.
//
// Output shape matches the backend response so the same UI renders both.

const WA_DEFAULT = "https://wa.me/6285195555610?text=Halo%20Gantari%20Edu%2C%20saya%20sudah%20mengisi%20assessment%20awal%20dan%20ingin%20diskusi%20rekomendasi%20kampus%20saya.";

function rec(negara, alasan, biaya, universitas) {
    return { negara, alasan, estimasi_biaya_tahunan_idr: biaya, universitas };
}

function uni(nama, kota, highlight) {
    return { nama, kota, highlight };
}

// Per-budget recommendation templates (Safe / Match / Ambitious in that order)
function recsByBudget(budget) {
    if (budget < 150_000_000) {
        return [
            rec("Malaysia", "Biaya kuliah & hidup paling ramah kantong, kampus berbahasa Inggris, jarak dekat dari Indonesia.", 90_000_000, [
                uni("Universiti Malaya", "Kuala Lumpur", "Top universitas Malaysia, peringkat global QS"),
                uni("Asia Pacific University (APU)", "Kuala Lumpur", "Spesialis teknologi & bisnis, multi-award"),
            ]),
            rec("Jerman (jalur universitas negeri)", "Mayoritas kampus negeri bebas biaya kuliah, hanya bayar biaya semester ~Rp 5-10 juta. Perlu persiapan dokumen, bahasa Jerman, & APS.", 110_000_000, [
                uni("TU Munich / RWTH Aachen / Heidelberg", "Berbagai kota", "Tuition-free, peringkat top dunia"),
                uni("Studienkolleg Pathway", "Berbagai kota", "Persiapan jalur masuk universitas negeri"),
            ]),
            rec("UK / Australia (hanya dengan beasiswa)", "Untuk budget ini, UK/Australia hanya realistis lewat beasiswa LPDP/Chevening/AAS atau pathway program.", 350_000_000, [
                uni("LPDP / Chevening / AAS Awardee", "—", "Jalur beasiswa penuh"),
            ]),
        ];
    }
    if (budget < 300_000_000) {
        return [
            rec("Malaysia (kampus swasta papan atas)", "Fasilitas premium dengan kurikulum twinning UK/Australia, biaya hidup terkontrol.", 180_000_000, [
                uni("Taylor's University", "Subang Jaya", "Top private Malaysia, kuat di Hospitality & Business"),
                uni("Monash University (Malaysia)", "Bandar Sunway", "Gelar sama persis dengan Monash Australia"),
            ]),
            rec("UK Pathway / Foundation", "Jalur pathway/foundation memberi akses ke kampus UK papan atas dengan biaya lebih terkontrol di tahun pertama.", 280_000_000, [
                uni("Coventry University", "Coventry", "Modern campus, kuat di Engineering & Business"),
                uni("University of Sussex (ISC Pathway)", "Brighton", "Akses ke kampus Russell Group via pathway"),
            ]),
            rec("Australia (regional / scholarship route)", "Kampus regional Australia menawarkan diskon biaya signifikan plus peluang Post-Study Work Visa lebih panjang.", 320_000_000, [
                uni("University of Wollongong", "Wollongong", "Top 200 dunia, lokasi regional"),
                uni("La Trobe University", "Melbourne", "Beasiswa internasional aktif"),
            ]),
        ];
    }
    if (budget < 500_000_000) {
        return [
            rec("Malaysia / Singapore (kampus internasional)", "Kampus UK/Australia cabang di Asia Tenggara dengan kualitas setara, biaya jauh lebih efisien.", 250_000_000, [
                uni("Monash University Malaysia", "Bandar Sunway", "Gelar identik dengan Monash Australia"),
                uni("James Cook University Singapore", "Singapore", "Cabang resmi JCU Australia"),
            ]),
            rec("United Kingdom", "Master 1 tahun (efisien waktu & ROI cepat), akses Russell Group, jaringan industri global.", 450_000_000, [
                uni("University of Warwick", "Coventry", "Top 10 UK · Russell Group"),
                uni("University of Manchester", "Manchester", "Top 6 UK · reputasi industri kuat"),
            ]),
            rec("Australia (mainstream)", "Group of Eight & Top Public, peluang Post-Study Work Visa hingga 4 tahun, lifestyle bagus.", 480_000_000, [
                uni("University of Melbourne", "Melbourne", "#1 di Australia, top 14 dunia QS"),
                uni("UNSW Sydney", "Sydney", "Top 20 dunia, kuat di Engineering & Business"),
            ]),
        ];
    }
    if (budget < 1_000_000_000) {
        return [
            rec("United Kingdom (Russell Group)", "Akses langsung ke top UK tanpa pathway. Master 1 tahun = ROI cepat, jaringan alumni global.", 700_000_000, [
                uni("University of Warwick", "Coventry", "Top 10 UK · Russell Group"),
                uni("University of Edinburgh", "Edinburgh", "Top 5 UK · multidisiplin kuat"),
            ]),
            rec("Australia (Group of Eight)", "Top 8 Australia, reputasi riset global, Post-Study Work Visa hingga 4 tahun.", 720_000_000, [
                uni("University of Melbourne", "Melbourne", "#1 Australia, top 14 QS"),
                uni("University of Sydney", "Sydney", "Top 20 dunia"),
            ]),
            rec("USA / Canada (selected)", "Pilihan top-tier Amerika Utara — UC Berkeley, UofT, McGill — perlu profil akademik kuat & timeline aplikasi panjang.", 950_000_000, [
                uni("University of Toronto", "Toronto", "Top 1 Canada · top 25 dunia"),
                uni("UCLA / NYU / Boston U.", "Various USA", "Top US private/public R1"),
            ]),
        ];
    }
    return [
        rec("Australia (Group of Eight)", "Pilihan paling stabil di level premium — kombinasi kualitas, lifestyle, dan jalur kerja jelas.", 720_000_000, [
            uni("University of Melbourne", "Melbourne", "#1 Australia, top 14 QS"),
            uni("Australian National University", "Canberra", "Top riset, kuat di Public Policy"),
        ]),
        rec("United Kingdom (Top 10)", "Russell Group elite — Oxbridge route, LSE, Imperial, UCL — kualifikasi global tertinggi.", 850_000_000, [
            uni("Imperial College London", "London", "Top 3 UK · STEM elite"),
            uni("LSE / UCL / King's College London", "London", "Top 10 UK · prestise global"),
        ]),
        rec("USA Top Universities", "Akses ke Ivy League, Stanford, MIT, Berkeley — dependsi pada nilai, SAT/GRE, dan portfolio.", 1_200_000_000, [
            uni("Harvard / MIT / Stanford", "Boston / Cambridge / Stanford", "Top 10 global"),
            uni("UC Berkeley / Columbia / Cornell", "USA", "Top 20 global"),
        ]),
    ];
}

function budgetNoteText(budget, country) {
    const inJt = Math.round(budget / 1_000_000);
    const isUKAUS = ["United Kingdom", "Australia", "USA", "United States", "Canada"].includes(country);
    const isAsia = ["Malaysia", "Singapore"].includes(country);
    const isEUcheap = ["Germany", "Jerman", "Netherlands", "Belanda"].includes(country);

    if (budget < 150_000_000) {
        if (isUKAUS) return `Budget ~Rp ${inJt} jt/tahun KONSERVATIF untuk ${country}. Realistis hanya via beasiswa penuh (LPDP/Chevening/AAS) atau pathway 1-tahun di Malaysia dulu.`;
        if (isAsia) return `Budget ~Rp ${inJt} jt/tahun MODERAT untuk ${country}. Cocok untuk kampus berkualitas dengan biaya hidup terkontrol.`;
        if (isEUcheap) return `Budget ~Rp ${inJt} jt/tahun MODERAT untuk ${country} via jalur universitas negeri. Perlu persiapan bahasa & dokumen lebih intensif.`;
        return `Budget ~Rp ${inJt} jt/tahun KONSERVATIF. Sweet spot: Malaysia, Jerman (jalur negeri), atau jalur beasiswa.`;
    }
    if (budget < 300_000_000) {
        if (isUKAUS) return `Budget ~Rp ${inJt} jt/tahun KONSERVATIF-MODERAT untuk ${country}. Realistis lewat pathway/foundation atau kampus regional + scholarship parsial.`;
        return `Budget ~Rp ${inJt} jt/tahun MODERAT. Cukup nyaman untuk Malaysia (private top), pathway UK, atau Australia regional.`;
    }
    if (budget < 500_000_000) {
        if (isUKAUS) return `Budget ~Rp ${inJt} jt/tahun MODERAT untuk ${country}. Cukup untuk master 1 tahun di UK atau Australia regional/mainstream.`;
        return `Budget ~Rp ${inJt} jt/tahun KUAT. Banyak pilihan: UK, Australia, atau kampus internasional di Asia dengan kualitas premium.`;
    }
    if (budget < 1_000_000_000) {
        return `Budget ~Rp ${inJt} jt/tahun SANGAT KUAT. Akses ke top tier UK Russell Group, Australia Group of Eight, dan selected US/Canada.`;
    }
    return `Budget ~Rp ${inJt} jt/tahun PREMIUM. Akses ke top global universities — Oxbridge, Ivy League, MIT/Stanford — tergantung profil akademik.`;
}

function readinessNoteText(degree) {
    if (!degree) return "Persiapkan dokumen utama: transkrip terjemahan, sertifikat bahasa (IELTS/TOEFL), motivation letter, dan paspor minimal valid 2 tahun.";
    const d = degree.toLowerCase();
    if (d.includes("s3") || d.includes("doctoral")) {
        return "Untuk S3: fokus pada supervisor fit, research proposal yang kuat, funding (scholarship/RA), dan academic CV dengan publikasi atau pengalaman riset.";
    }
    if (d.includes("s2") || d.includes("master")) {
        return "Untuk S2: persiapkan IPK transkrip S1 (idealnya ≥3.0), IELTS ≥6.5 / TOEFL ≥80, motivation letter yang jelas tentang career goal, dan rencana ROI master.";
    }
    if (d.includes("s1") || d.includes("foundation") || d.includes("diploma")) {
        return "Untuk S1/Foundation: persiapkan nilai rapor (semester 4-6), sertifikat bahasa, parental sponsor letter, dan timeline aplikasi minimal 6-12 bulan sebelum intake.";
    }
    if (d.includes("short")) {
        return "Untuk short course: cek visa requirement (biasanya visitor/tourist), portfolio relevan, dan timeline pendek (1-3 bulan persiapan).";
    }
    return "Persiapkan dokumen utama: transkrip terjemahan, sertifikat bahasa (IELTS/TOEFL), motivation letter, dan paspor minimal valid 2 tahun.";
}

export function clientSideFallback({ current_education, target_degree, target_country, budget_idr }) {
    const recs = recsByBudget(Number(budget_idr) || 200_000_000);
    const country = target_country || "Belum yakin";
    const budgetNote = budgetNoteText(Number(budget_idr) || 200_000_000, country);
    const readinessNote = readinessNoteText(target_degree);
    const ringkasan = country === "Belum yakin"
        ? `Karena negara tujuanmu belum pasti, kami pemetakan 3 jalur paling realistis untuk profilmu. Counselor Senior Gantari akan bantu memilih yang paling tepat.`
        : `Berdasarkan target ${target_country || "kuliahmu"} dan budget yang kamu pilih, ini pemetaan awal jalur paling realistis. Counselor Senior Gantari akan validasi dengan dokumen & nilai aktualmu.`;

    return {
        ringkasan,
        rekomendasi: recs,
        budget_note: budgetNote,
        readiness_note: readinessNote,
        next_step: "Diskusikan pilihan ini dengan Counselor Gantari agar rekomendasi kampus dan jurusan bisa disesuaikan dengan nilai, dokumen, intake, dan tujuan kariermu.",
        disclaimer: "Hasil ini adalah pemetaan awal otomatis. Counselor Gantari akan membantu validasi secara personal.",
        is_client_fallback: true,
        wa_link: WA_DEFAULT,
    };
}

export function isValidWhatsApp(raw) {
    if (!raw) return false;
    const digits = String(raw).replace(/[^\d]/g, "");
    // Indonesian numbers: 08xxx (10-13 digits) OR 628xxx (11-14 digits) OR +628xxx
    if (digits.length < 9 || digits.length > 15) return false;
    if (digits.startsWith("0")) return digits.length >= 10 && digits.length <= 13;
    if (digits.startsWith("62")) return digits.length >= 11 && digits.length <= 14;
    if (digits.startsWith("8")) return digits.length >= 9 && digits.length <= 12;
    return digits.length >= 10;
}

export function normalizePhone(raw) {
    const digits = String(raw || "").replace(/[^\d]/g, "");
    if (digits.startsWith("0")) return "62" + digits.slice(1);
    if (digits.startsWith("8")) return "62" + digits;
    return digits;
}
